module.exports = __webpack_public_path__ + "img/AMWETCarousel_feet.52832bf3.jpg";